class Cache {
  prefix = "terra-map-"
  localStore: any

  constructor() {
    if (window.localStorage) {
      try {
        this.localStore = window.localStorage
        setInterval(() => {
          console.log("clean local storage")
          Object.keys(this.localStore).forEach((key) => {
            let ex = this.localStore.getItem(this.prefix + key + "_ex")
            if (ex) {
              var start = new Date().getTime()
              if (start > ex) {
                this.localStore.removeItem(this.prefix + key)
                this.localStore.removeItem(this.prefix + key + "_ex")
              }
            }
          })
        }, 60000)
      } catch (e) {
        console.log("Local storage not supported on this browser. May need to use cookies")
      }
    }
  }

  cacheEx(key: string, value: any, expireInSeconds: number, prefix = "") {
    if (this.localStore) {
      let toStr = JSON.stringify(value)
      this.localStore.setItem((prefix || this.prefix) + key, toStr)

      var start = new Date().getTime()
      let ttl = start + expireInSeconds * 1000
      this.localStore.setItem((prefix || this.prefix) + key + "_ex", ttl)
    } else {
      console.log("No local storage. cant store value")
    }
  }
  cache(key: string, value: any, prefix = "") {
    if (this.localStore) {
      let toStr = JSON.stringify(value)
      this.localStore.setItem((prefix || this.prefix) + key, toStr)
    } else {
      console.log("No local storage. cant store value")
    }
  }

  removeAll() {
    console.log("To remove:", Object.keys(this.localStore))
    Object.keys(this.localStore).forEach((key) => {
      this.localStore.removeItem(key)
      console.log("-> Removed", key)
    })
  }

  remove(key: string, prefix = "") {
    if (this.localStore) {
      this.localStore.removeItem((prefix || this.prefix) + key)
      this.localStore.removeItem((prefix || this.prefix) + key + "_ex")
    } else {
      console.log("No local storage. cant remove value")
    }
  }

  cached(key: string, prefix = "") {
    if (this.localStore) {
      let fromStr = this.localStore.getItem((prefix || this.prefix) + key)
      if (fromStr) {
        let ex = this.localStore.getItem((prefix || this.prefix) + key + "_ex")
        if (ex) {
          var start = new Date().getTime()
          if (start > ex) {
            this.localStore.removeItem((prefix || this.prefix) + key)
            this.localStore.removeItem((prefix || this.prefix) + key + "_ex")
            return null
          }
        }
        return JSON.parse(fromStr)
      }
      return null
    } else {
      return null
    }
  }
}

export const cacheSrv = new Cache()
